import React from "react";

export default function NumberSection() {
  return (
    <section
      className="bg-cover bg-center text-white py-16 mt-16 rounded-3xl overflow-hidden relative max-w-7xl mx-auto"
      style={{
        backgroundImage: "url('/assests/images/LandingPage/bg-img11.webp')",
      }}
    >
      {" "}
      {/* Grid with custom width ratio on md+ screens */}
      <div className="grid grid-cols-1 md:grid-cols-[40%_60%] gap-8 items-center">
        {/* Left Side Content */}
        <div className="pl-6 md:pl-10">
          <h2 className="text-3xl md:text-5xl font-bold mb-4">
            Get a centralized space for all your retail store signage execution
          </h2>
          <p className="text-gray-300 mb-6">
            A cutting edge platform which not only appoints signage vendors and
            service providers at a hyperlocal level, but also offers agility,
            visibility and efficiency to the Brands.
          </p>
          <button className="bg-blue-500 text-white px-6 py-2 rounded-full font-medium shadow-md hover:bg-blue-600">
            Start now
          </button>
        </div>

        {/* Image & Labels */}
        <div className="relative md:left-24">
          <img
            src="/assests/images/LandingPage/dashboard.webp"
            alt="Dashboard"
            className="rounded-xl w-full md:w-5/6"
          />
          <img
            src="/assests/images/LandingPage/hero-1.webp"
            alt="hero1"
            className="absolute bottom-20 left-0 md:bottom-28 md:-left-8 animate-bounce w-16 md:w-28 h-auto"
          />
          <img
            src="/assests/images/LandingPage/hero-2.webp"
            alt="hero2"
            className="absolute top-32 left-4 md:top-56 md:left-8 animate-bounce w-16 md:w-28 h-auto"
          />
          <img
            src="/assests/images/LandingPage/hero-3.webp"
            alt="hero3"
            className="absolute bottom-8 right-4  md:bottom-12 md:right-40 animate-bounce w-16 md:w-28 h-auto"
          />
        </div>
      </div>
      {/* Metrics Section */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-start ml-16 text-white mt-16">
        <div>
          <h3 className="text-3xl font-bold">4.8/5</h3>
          <p className="text-sm text-gray-300 mt-1">Client feedback rating</p>
          <p className="text-xs text-gray-400">
            satisfaction score from clients on completed projects.
          </p>
        </div>
        <div>
          <h3 className="text-3xl font-bold">92/100</h3>
          <p className="text-sm text-gray-300 mt-1">Team productivity score</p>
          <p className="text-xs text-gray-400">
            based on task completion rates, task duration, and collaboration.
          </p>
        </div>
        <div>
          <h3 className="text-3xl font-bold">12000+</h3>
          <p className="text-sm text-gray-300 mt-1">Installed Signages</p>
          <p className="text-xs text-gray-400">
            per task from assignment to completion.
          </p>
        </div>
      </div>
    </section>
  );
}
